<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h3>AM Past Due Report</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="busy">
          <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="align-middle" />
        </div>
        <div v-else>
          <table class="mt-2 table fixed-table">
            <thead>
              <tr>
                <th v-for="col in columns" :key="col.label">
                  {{ col.label }}
                </th>
              </tr>
            </thead>
            <tbody v-for="vendor in items" :key="vendor.name">
              <tr>
                <th :colspan="columns.length">
                  <h5 style="background-color:gainsboro;">{{vendor.name}}</h5>
                </th>
              </tr>
              <tr v-for="item in vendor.items" :key="item.partNum">
                <td v-for="col in columns" :key="col.label">
                  <span v-if="col.key == 'partnum'">
                    <router-link target='_blank' :to="{ name: 'Qty Calculations', query: { partNum: item.partnum } }">
                      {{item.partnum}}
                    </router-link>
                  </span>
                  <span v-else-if="col.key == 'datescheduledfulfillment'">
                    <NiceDate :value='String(item.datescheduledfulfillment)' :showTime=false :isUtc=false />
                  </span>
                  <span v-else-if="col.key == 'poNum'">
                    <router-link target='_blank' :to="{ name: 'PO Lookup', query: { poNum: item.poNum } }">
                      {{item.poNum}}
                    </router-link>
                  </span>                  
                  <span v-else-if="col.key == 'qtytofulfill'">
                    {{ Number(item.qtytofulfill) }} {{ item.uomcode }}
                  </span>                  
                  <span v-else-if="col.key == 'receiptitemqty'">
                    {{ Number(item.receiptitemqty) }} {{ item.uomcode }}
                  </span>                  
                  <span v-else-if="col.key == 'backordered'">
                    {{ Number(item.qtytofulfill) - Number(item.receiptitemqty) }} {{ item.uomcode }}
                  </span>
                  <span v-else>{{item[col.key]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate.vue';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
    FingerprintSpinner
  },
  data() {
    return {
      filter: '',
      busy: false,
      columns: [
        { key: 'partnum', label: 'Part Number', sortable: true },
        { key: 'partdescription', label: 'Part Description', sortable: true },
        { key: 'datescheduledfulfillment', label: 'Scheduled Fulfillment', sortable: true },
        { key: 'ponum', label: 'PO Number', sortable: true },
        { key: 'qtytofulfill', label: 'Ordered', sortable: true },
        { key: 'receiptitemqty', label: 'Received', sortable: true },
        { key: 'backordered', label: 'Backordered', sortable: true },
      ],
      items: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.busy = true;
      axios.get(`${BASE_API}/fishbowl/reports/past-due-report`).then(response => {
        response.data.forEach(item => {
          let vendor = this.items.find(x => x.name === item.vendorname);
          if (typeof(vendor) == 'undefined') {
            vendor = { name: item.vendorname, items: [] };
            this.items.push(vendor);
          }
          vendor.items.push(item);
        });
        this.busy = false;
      }).catch(error => {
        console.error(error);
      });
    },
  },
}
</script>

<style scoped>
h5 {
  margin-bottom: 0px;
  padding: 2px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/purchasing/PastDueReport.vue